/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Plan_Tiles_HintInputs */

const cs_billing_plan_tiles_hint = /** @type {(inputs: Billing_Plan_Tiles_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyberte tarif. Office sedí většině týmů.`)
};

const en_billing_plan_tiles_hint = /** @type {(inputs: Billing_Plan_Tiles_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a plan. Office is the best fit for most teams.`)
};

/**
* | output |
* | --- |
* | "Choose a plan. Office is the best fit for most teams." |
*
* @param {Billing_Plan_Tiles_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_plan_tiles_hint = /** @type {((inputs?: Billing_Plan_Tiles_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Plan_Tiles_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_plan_tiles_hint(inputs)
	return cs_billing_plan_tiles_hint(inputs)
});